import { congestionLevel } from 'src/utils';

import { AddressDataProps, FilteredNetworkCheckProps } from '..';

import { getAddressReplaceText } from './getAddressReplaceText';
import { mappedNetworkCongestions } from './mappedNetworkCongestions';
import { mappedNetworkCongestionsV2 } from './mappedNetworkCongestionsV2';
import { replaceUrlParameters } from './replaceUrlParameters';

type HandleCongestionSuccesRequestProps = {
  address?: AddressDataProps;
  level?: string;
  networkCheck?: FilteredNetworkCheckProps;
  version: 'v1' | 'v2';
};

export const handleCongestionSuccessRequest = ({
  address,
  level,
  networkCheck,
  version,
}: HandleCongestionSuccesRequestProps) => {
  const replaceText = getAddressReplaceText({
    city: address?.city,
    postalCode: address?.postalCode || '',
    houseNumber: address?.houseNumber || '',
    houseNumberAddition: address?.houseNumberAddition,
  });

  // Maps the urlParams for the congestion page route.
  const replaceTextOutage = replaceUrlParameters({
    ...address,
    postalCode: address?.postalCode ?? '',
  });

  // If the version is v2 we use the new mappedNetworkCongestionsV2 function.
  if (version === 'v2') {
    const networkCongestions = mappedNetworkCongestionsV2({
      level: level,
      networkCheck: networkCheck,
      replaceText: { ...replaceText, ...replaceTextOutage },
    });

    return networkCongestions;
  }

  // If the version is v1 we use the old mappedNetworkCongestions function.
  const mappedLevel = congestionLevel(level);

  // If the level is undefined we log it to the console.
  if (!mappedLevel) {
    console.error(`Unknown congestion level ${level}`);
  }

  const networkCongestions = mappedNetworkCongestions({
    level: mappedLevel,
    networkCheck: networkCheck,
    replaceText: { ...replaceText, ...replaceTextOutage },
  });

  return networkCongestions;
};
